'use client'
import { useI18N } from '@/context/I18NContext'
import { DropdownMenuItem } from '../../ui/dropdown-menu'
import { changeLanguage } from '../actions'

export const ChangeLanguageItem = () => {
	const { language } = useI18N()

	return (
		<DropdownMenuItem
			onClick={() => changeLanguage(language === 'en' ? 'nb' : 'en')}
		>
			{language === 'en' ? 'Norsk' : 'English'}
		</DropdownMenuItem>
	)
}
